import { render, staticRenderFns } from "./EnvoyerNotification.vue?vue&type=template&id=31e456e2&scoped=true"
import script from "./EnvoyerNotification.vue?vue&type=script&lang=js"
export * from "./EnvoyerNotification.vue?vue&type=script&lang=js"
import style0 from "./EnvoyerNotification.vue?vue&type=style&index=0&id=31e456e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e456e2",
  null
  
)

export default component.exports